import React from 'react';


const Footer = () => {
    return (
        <footer style={{position: 'relative',bottom: '0',width: '100%'}} className=''>
        <div className="w3-row-padding w3-black">  
            <div className="w3-half mt-4">
                <h4 style={{textAlign:'justify', paddingLeft: '10px', fontFamily: 'Arial'}}>BUILDEX</h4>
                <p style={{paddingLeft: '10px', fontFamily:'Verdana'}}>
                Our goal is to create a one-stop shop for construction material buyers <br /> and sellers. This platform will bring together vendors and customers in <br /> a single, convenient location, making it easier 
          for both parties to find <br /> what they need. 
                </p>
            </div>  
            <div className="w3-quarter">
                    <img src="/images/build_ex_logo.png" className="float-right mt-4" alt="..." style={{width: '140px', height: '130px'}}/>
            </div>
            <div className="w3-quarter">
                <p style={{padding:'25px', paddingLeft: '10px'}}>
                    <br/>
                    <i className="fa fa-map-marker" style={{fontSize:'15px'}}></i> &emsp;  BUILDEX .Ltd, ISLAMABAD<br/>
                    <i className="fa fa-phone" style={{fontSize:'15px'}}></i> &emsp; +923244307111<br/>
                    <i className="fa fa-envelope-open" style={{fontSize:'15px'}}></i> &emsp; buildex.pakistan@gmail.com<br/>
                </p>
            </div>
        </div>
    </footer> 
    );
};

export default Footer;
